import React, { useEffect, useState } from 'react'
import { Phone, MessageSquare } from 'lucide-react'

/**
 * Mobile-only floating Call / Text buttons, bottom-right (the only corner free
 * of the accessibility button + social rail on the left). ScrollToTop shifts up
 * above this bar on small screens. Desktop unchanged (md:hidden).
 */
const MobileContactBar: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY > window.innerHeight * 0.72)
    updateVisibility()
    window.addEventListener('scroll', updateVisibility, { passive: true })
    window.addEventListener('resize', updateVisibility)
    return () => {
      window.removeEventListener('scroll', updateVisibility)
      window.removeEventListener('resize', updateVisibility)
    }
  }, [])

  return (
    <div
      aria-hidden={!visible}
      className={`fixed z-40 right-3 flex items-center gap-2 transition-all duration-300 md:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-16 opacity-0'}`}
      style={{ bottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <a
        href="tel:+13025428591"
        tabIndex={visible ? undefined : -1}
        aria-label="Call Shawn McDonnell"
        className="inline-flex items-center gap-1.5 h-11 px-4 rounded-full bg-accent-gold text-primary-ink font-display font-medium text-[11px] uppercase tracking-[0.15em] shadow-lg border border-accent-gold/60"
      >
        <Phone size={14} aria-hidden="true" />
        Call
      </a>
      <a
        href="sms:+13025428591"
        tabIndex={visible ? undefined : -1}
        aria-label="Text Shawn McDonnell"
        className="inline-flex items-center gap-1.5 h-11 px-4 rounded-full bg-primary-ink/90 backdrop-blur-md text-white font-display font-medium text-[11px] uppercase tracking-[0.15em] shadow-lg border border-white/20"
      >
        <MessageSquare size={14} aria-hidden="true" />
        Text
      </a>
    </div>
  )
}

export default MobileContactBar
